import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'app-about',
  templateUrl: './smartworld.component.html',
  styleUrls: ['./smartworld.component.css']
})

export class AboutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
